// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TXim","top":"styles_top__1ZEOU","left":"styles_left__21VmA","description":"styles_description__1hhHb"};